export default __webpack_public_path__ + "locales/pt/InviteDialog.json?hash=5701888cc7add25f824a3fd0ca5f30b4";